export const TRANSLATE_KEYS_EN_US = {
  //Login
  login_email: 'E-mail',
  login_senha: 'Password',
  entrar: 'Login',
  esqueci_minha_senha: 'Forgot your password',

  //Recuperar Senha
  recuperar_senha_email: 'E-mail',
  recuperar_senha: 'Recover password',
  voltar_login: 'Go back to login',
  recuperar_senha_mensagem_aviso: 'Don\'t worry, just enter your e-mail address below and we\'ll send you a link to recover your access.',

  // Cadastro de senhas
  gerenciar_senhas_criar_senha: 'Register password',
  gerenciar_senhas_titulo: 'Create password',

  // Placeholders
  placeholder_email: 'Enter your e-mail here',
  placeholder_senha: 'Enter your password here',
  placeholder_documento: 'Enter your document here',
  placeholder_celular: 'Enter your phone number',
  placeholder_empresa: 'Enter the name of your company here',
  placeholder_selecione: 'Select',
  placeholder_cargo: "Enter your job here",
  placeholder_nome_empresa: "Enter the company name here",
  placeholder_cnpj_empresa: "Enter the company's CNPJ here",

  // Perfil
  perfil_cadastre_foto: 'Register your photo',
  perfil_dados_pessoais: 'Personal data',
  perfil_confira_seus_dados: 'Check your registered data and update it if necessary.',
  perfil_alterar_dados: 'Change data',
  perfil_email: 'E-mail',
  perfil_senha: 'Password',
  perfil_confirmar_senha: 'Confirm password',
  perfil_direitos_autorais_rodape: 'Copyright ©2000 - 2025.',
  perfil_todos_direitos_reservados_rodape: 'All rights reserved.',
  perfil_isencao_responsabilidade_conteudo_rodape: 'All content on the site, including all photos, images, image sets, layouts, trade dress, displayed here are purely illustrative and are the exclusive property of Grupo Imply or its partners.',
  perfil_isencao_responsabilidade_reproducao_rodape: 'Reproduction, in whole or in part, of any identity element is prohibited without express authorization.',
  perfil_isencao_responsabilidade_violacao_rodape: 'Violation of any mentioned right will result in civil and criminal liability under the terms of the law.',
  perfil_informacoes_imply_rodape: 'Imply Rental Equip. and Serv. | CNPJ: 14.928.256/0001-78 | Imply Technology Highway, 1.111',
  perfil_requisito_letra_minuscula: 'Lowercase letter',
  perfil_requisito_letra_maiuscula: 'Uppercase letter',
  perfil_requisito_incluir_numeros: 'Include numbers',
  perfil_requisito_caracter_especial: 'Special character',
  perfil_requisito_mais_de_8_digitos: 'More than 8 digits',
  perfil_requisito_confirmar_senha_igual: 'Equal passwords',
  perfil_requisito_sem_espacos: 'Password must not contain spaces',
  perfil_salvar_atualizacao: 'Save update',
  perfil_cancelar_alteracao: 'Cancel change',
  perfil_boas_vindas: 'Hello',
  perfil_alterar_senha: 'Change password',
  perfil_sucesso_alterar_senha: 'Password changed successfully!',
  perfil_nivel_permissao: 'Permission level',
  instituicao_ensino: 'Educational institution.',

  //Eventos
  eventos_ativos: 'Active events',
  eventos_inativos: 'Inactive events',

  //Detalhes do evento
  incluir_colaboradores: 'Include employees',
  status_negado: 'Denied',
  status_pendente: 'Pending',
  status_removido: 'Removed',
  status_aprovado: 'Approved',
  nenhum_colaborador_evento: 'No employee in the event',
  incluir_veiculos: 'Include vehicles',
  nenhum_veiculo_evento: 'No vehicles in the event',
  colaboradores: 'Employees',
  nenhum_colaborador_disponivel: 'No employees available',
  veiculos: 'Vehicles',
  nenhum_veiculo_disponivel: 'No vehicles available',
  aguardando_aprovacao_do_gestor_do_evento: 'Waiting for approval from the event manager',
  gestor_negou_a_devida_solicitacao: 'The manager denied the request for access to the appropriate employee / vehicle',
  este_colaborador_foi_removida_a_autorizacao_pelo_permissionario: 'Permission request removed',
  remove_solicitacao_de_autorizacao_do_acesso: 'Removes the access request and blocks access if previously approved',
  baixa_arquivo_de_autorizacao: 'Download the file for printing',
  envia_um_email_com_anexo_para_o_colaborador: 'Send the file for printing directly to the e-mail informed at the time of registration of the employee',
  informacoes: 'Information',
  solicitar_novamente_autorizacao: 'Re-request access approval',
  deseja_remover_a_solicitacao_do_evento_para_o_colaborador: 'Do you want to remove the access request? (If previously authorized, access will be blocked)',
  deseja_enviar_email_para_o_colaborador_selecionado: 'Do you want to send an e-mail to the selected employee?',
  acesso_enviao_para_o_email_colaborador: 'E-mail successfully sent',
  caso_o_email_existir_sera_enviado_email: 'If the e-mail entered is correct, will an e-mail be sent with the new password, confirm sending the new password?',
  acesso_enviado_pelo_email: 'Access sent to the collaborator\'s e-mail',

  // Colaboradores
  colaborador: 'Collaborator',
  colaborador_ver_todos: 'See all Collaborator',
  colaborador_incluir_novo: 'Include new collaborators',

  //Listagem de colaboradores
  buscar_colaborador: 'Search employee',
  buscar_permissionario: 'Search by permittee',
  cadastrar: 'Register',
  atencao: 'Warning',
  deseja_excluir_colaborador: 'Do you want to delete the employee ',
  deseja_excluir: 'Do you want to delete ',
  cancelar: 'Cancel',
  confirmar: 'Confirm',
  colaborador_placeholder_nome_colaborador: 'Enter the collaborator\'s name here',
  colaborador_placeholder_email_colaborador: 'Enter the collaborator\'s e-mail here',
  colaborador_importar_lista: 'Import collaborator list',
  colaborador_importar_lista_suporte_csv: 'Support only for CSV files',
  colaborador_total_cadastros: 'Total number of people registered',
  colaborador_com_onboarding: 'With Onboarding',
  colaborador_sem_onboarding: 'No Onboarding',
  buscar_empresa: 'Search companies',
  onboarding: 'Onboarding',
  possui_onboarding: 'Does it have onboarding?',

  //Cadastro de colaboradores
  cadastrar_colaborador: 'Register employee',
  editar_colaborador: 'Edit employee',
  documento: 'Document',
  nome: 'Name',
  cadastro_email: 'E-mail',
  telefone: 'CellPhone',
  sucesso: 'Success',
  colaborador_cadastrado_sucesso: 'Employee successfully registered!',
  colaborador_editado_sucesso: 'Employee successfully edited',
  finalizar: 'Finish',
  ocorreu_erro_cadastro: 'Registration could not be completed at the moment. Please try again.',
  ok: 'Ok',
  colaborador_nome_limitado_150_characteres: 'Name: maximum 150 characters reached',
  colaborador_email_limitado_100_characteres: 'E-mail: maximum 100 characters reached',
  colaborador_informe_nome_completo: 'Enter the full name',
  informe_um_celular_valido: 'Please enter a valid number',
  informe_um_documento_valido: 'Please provide a valid document',
  informe_um_email_valido: 'Please enter a valid e-mail',
  editar: 'Edit',
  informe_todos_os_campos: 'Inform all fields!',
  colaborador_ponto_focal: 'Focal point',
  colaborador_deletado_sucesso: 'Collaborator successfully deleted!',

  //Visitantes
  visitante_visita_singular: 'Visit',
  visitante_inicio_visita: 'Start of visit',
  visitante_fim_visita: 'End of visit',
  visitante_agendar_visita: 'Schedule another visit',
  visitante_remover_visita: 'Remove added visit',
  visitante_informacao_inputs: 'Enter the name and e-mail of the visitor you wish to invite.',
  visitante_importar_lista: 'Import visitor list',
  visitante_importar_lista_suporte_csv: 'Support only for CSV files',
  visitante_botao_enviar: 'Send invitation(s)',
  visitante_placeholder_nome_visitante: 'Enter the visitor\'s name here',
  visitante_placeholder_email_visitante: 'Enter the visitor\'s e-mail here',
  visitante_data_invalida: 'The start date/time cannot be greater than the end date.',
  visitante_inclusao_data_inicio: 'Start date of inclusion',
  visitante_inclusao_data_fim: 'End date of inclusion',
  visitante_mostrar_filtros: 'More filters',
  visitante_ocultar_filtros: 'Hide filters',
  visitante_periodo_visita: 'Visit period status',
  buscar_visitante: "Search visitor",
  visitante_agenda_visitas: 'Visits',
  visitante_deletar: "Delete visitor",
  visitante_visita_atualizada: "Visit successfully updated!",
  visitante_incluir_novo: "Include new visitors",
  deseja_excluir_visitante: 'You want to exclude the visitor ',
  visitante_ver_todos: 'See all visitors',

  //Alunos
  buscar_aluno: 'Search Student',
  aluno_incluir_novo: 'Include new students',
  aluno_informacao_inputs: 'Enter the name and e-mail address of the student you wish to invite.',
  aluno_placeholder_email_aluno: 'Enter the students e-mail address here',
  aluno_placeholder_nome_aluno: 'Enter the students name here',
  aluno_importar_lista: 'Import student list',
  aluno_ver_todos: 'See all students',
  deseja_excluir_aluno: 'You want to exclude the student ',
  visitante_preencha_campos: 'Fill in the dates above to proceed',
  corrija_erro_data_para_prosseguir: 'Correct the date conflicts to proceed',
  conflito_datas: 'There is a conflict between the dates, correct them to proceed',

  //Listagem de veículos
  buscar_veiculo: 'Search vehicle',
  deseja_excluir_veiculo: 'Do you want to delete the vehicle ',

  //Cadastro de veículos
  cadastrar_veiculo: 'Register vehicle',
  veiculo_marca_modelo: 'Brand / Model',
  veiculo_cor: 'Color',
  veiculo_placa: 'License plate',
  veiculo_status: 'Status',
  ativo: 'Active',
  inativo: 'Inactive',
  veiculo_tipo: 'Type',
  veiculo_automovel: 'Car',
  veiculo_motocicleta: 'Motorcycle',
  veiculo_caminhao: 'Truck',
  veiculo_cadastrado_sucesso: 'Vehicle successfully registered!',
  veiculo_editado_sucesso: 'Vehicle successfully edited!',
  veiculo_placa_minimo_4_maximo_50: 'Enter a valid License plate, minimum: 4 Maximum: 50',
  veiculo_cor_50_characteres: 'Please enter a valid color, Maximum: 50',
  veiculo_marca_modelo_minimo_4_maximo_50: 'Please enter a valid brand / model, minimum: 4 Maximum: 50',

  // Sucesso
  sucesso_convite_enviado: 'Invitation sent successfully',
  sucesso_tudo_pronto: 'All set!',
  sucesso_voltar: 'Go back',
  sucesso_voltar_login: 'Back to login',
  sucesso_mensagem_verificar_spam: 'If you don\'t find any e-mails in your inbox, also check your spam folder',
  sucesso_pronto_acesso_caldeira: 'Are you ready to access Caldeira with your face',

  //Onboard
  onboard_label_selecione_genero: 'Select your gender',
  onboard_label_selecione_tipo_documento: 'Select the type of your document',
  onboard_label_documento: 'Document',
  onboard_label_celular: 'Cellphone',
  onboard_label_empresa: 'Your company',
  onboard_label_data_nascimento: 'Birth Date',
  onboard_label_cargo: 'Job',
  onboard_button_pronto: 'I\'m ready',
  onboard_convidado_email: 'You have been invited with the e-mail',
  onboard_instituicao: 'by the institution',
  onboard_confirme_dados_reconhecimento_facial: 'Confirm your data and perform facial recognition to access Caldeira Institute.',
  onboard_confirme_dados_recepcao: 'Confirm your data to access Caldeira Institute.',
  onboard_informacoes_enviadas: 'Information sent successfully',
  onboard_centralize_rosto: 'Center your face in the space',
  onboard_rosto_capturado: 'Face captured',
  onboard_capturar_imagem: 'Capture image',
  onboard_capturar_novamente: 'Capture again',
  onboard_enviar: 'Send',
  onboard_voltar: 'Back',
  onboard_foto_titulo: 'Take a photo',
  onboard_erro_camera: 'Could not access the camera. Check your browser permissions and try again.',
  onboard_erro_enviar_foto: 'Error sending the photo. Please try again.',

  // Gêneros
  genero_nao_especificar: 'Not specified',
  genero_masculino: 'Male',
  genero_feminino: 'Female',
  genero_outros: 'Other',

  //Informe de acessos
  informe_acessos: 'Access report',
  evento: 'Event',
  todos: 'All',
  buscar: 'Search',
  selecione_um_evento: 'Select an event',
  selecione_um_colaborador_veiculo: 'Select a Contributor / Vehicle',

  nao_colaboradores: 'Collaborators not found!',
  nao_veiculos: 'Vehicles not found!',
  nao_busca: 'Not found!',

  ac_restrito: 'Restricted access',
  pg_moveis: 'Page intended for mobile devices.',

  apr_img: 'Your image was for approval!',
  msn_img: 'If the image is not suitable, decline and send a new invitation to the user',
  recusar: 'Decline',
  aceitar: 'Accept',
  prosseguir: 'Proceed',
  capturar: 'Capture',

  dicas_1: 'Don\'t take blurry or shady photos.',
  dicas_2: 'Don\'t take pictures with people next to you or with accessories that cover your face.',
  dicas_3: 'Use this image as a reference, an image with good lighting is ideal for it to be readable.',
  dicas_4: 'Use our template to position your face and leave your image in the correct sending pattern!',

  qrcode: 'Qrcode',
  smartcard: 'SmartCard',
  facial: 'Facial',
  foto_pend: 'Photo pend.',
  pg_invalido: 'PAGE DOES NOT EXIST!',
  vincular_facial: 'Link to facial',

  whats_msn1: 'Hello, ',
  whats_msn2: '. Click on the link to register your image in the accreditation system of ',
  whats_msn3: '. The link is valid for 24 hours. Remember to register before this deadline, otherwise the accreditation will be invalidated. This is an automatic message, please do not reply. Link',

  dicas: 'Tips',
  credenciamento: 'Accreditation',
  cod_acesso: 'ACCESS CODES',
  search_codigos: 'Search codes',
  nenhum_codigo_encontrado: 'No code found or already linked!',
  descricao: 'Description',
  codigo: 'Code',

  error1: 'Token expired, please ask your manager again for the address for this page!',
  error2: 'Person not registered',
  error3: 'You have already registered the image, please wait for approval!',
  error4: 'There are no entries',
  error5: 'No description',
  cpf_valida_obrigatoriedade: '*CPF is mandatory',
  cpf_valida_numero_digitos: '*CPF must have 11 digits',
  cpf_invalido: '*Invalid CPF',
  cnpj_invalido: '*Invalid CNPJ',
  campo_obrigatorio: '*Required Field',
  data_invalida: "Incorrect date",
  data_nascimento_invalida: "Please enter a valid birth date.",

  error6: 'Description too short',

  _perfil: 'Profile',
  _eventos: 'Events',
  _colaboradores: 'Collaborators',
  _visitantes: 'Visitors',
  _alunos: 'Students',
  _veiculos: 'Vehicles',
  _codigo: 'Access codes',
  _informe: 'Access report',
  _sair: 'Exit',
  _portaria: 'Reception',
  _empresa: 'Companies',

  gerar: 'Generate code',

  imply_nome_maiusculo: 'IMPLY',
  imply_nome_titlecase: 'Imply',

  concluir: 'Submit',

  informe_nome_valido: 'Please enter a valid name',
  informe_email_valido: 'Please enter a valid e-mail address',
  informe_documento_valido: 'The document entered does not match the document registered',

  assinar_newsletter: 'Subscribe to Caldeira\'s newsletter',
  assinar_newsletter_outsider: 'I wish to receive newsletters, information about programs, registrations, events, initiatives from Instituto Caldeira and communications related to partners and ecosystem actions.',
  concordo_com_termos: 'I agree to the terms',
  sucesso_importacao_pessoa: 'Import successful!',
  sem_informacao: 'Not informed',
  empresa: 'Company',
  ou: 'or',
  termo: 'LGPD Term',
  ver_mais: 'View more',
  ver_menos: 'View less',
  gestor: 'Manager',
  linha: 'Line',
  info_modelo_csv_arquivos: 'CSV files must be separated by ";" or ",". Click',
  aqui: 'here',
  info_modelo_csv_baixar: 'to download a template.',
  colaborador_campos_obrigatorios: ' Required fields: Name, E-mail.',
  visitante_campos_obrigatorios: ' Required fields: Name, E-mail, Start date of visit (01/01/2000 00:00), End date of visit (31/01/2000 23:59).',
  aluno_campos_obrigatorios: ' Required fields: Name, E-mail, Start date of visit (01/01/2000), End date of visit (31/01/2000).',

  pessoa_incluir_novo: "Add person",
  buscar_pessoas: "Search person by name or e-mail",
  visitante: 'Visitor',
  aluno: 'Student',
  pessoa_email: "E-mail",
  pessoa_nome: "Name",
  visita_duracao: "Duration",
  visita_motivo: "Reasons",
  visita_dthr_inicio: "Start",
  visita_dthr_fim: "End",
  visita_complemento: "Complement",
  portaria_qrcode_visita: "QR code",
  send_email: "Send E-mail",
  voltar: "Back",
  add_visita: "Add Visit",
  ver_qrcode: "View QR Code visit",
  visitas_total_encontradas: "Total Visits Found",
  visita_incluir_novo: "Include new visit with QRcode",

  enviar_email_onboarding: "Send onboarding e-mail",
  deletar_colaborador: "Delete employee",
  deletar_aluno: "Delete student",
  editar_aluno: "Edit student",
  alterar_senha: "Click here to change your password",
  permissionario: 'Permittee',
  email_enviado: "E-mail sent",

  notifications: 'Notifications',
  _news: 'News',
  versao: 'Version',
  app: 'APP',
  ver_news: 'See new',
  add_empresa: "New company",
  complete_onboarding: 'Complete onboarding',
  agenda_visitas: 'Visitor / Student visits',
  deletar_selecionados: "Delete selected item(s)",
  confirmacao_exclusao: "Are you sure you want to proceed with the exclusion?",
  pesquisar: "Search",
  limpar_filtros: "Clear filters",
  visita_deletada_sucesso: "Visit(s) deleted successfully!",
  sim: "Yes",
  nao: "No",
  passaporte: "Passport",
  acoes: "Actions",
  salvar: "Save",
  pessoas: "People",
  sem_registro: "No registration",
  nome_empresa: "Company name",
  empresa_ver_todas: 'See all companies',
  sucesso_cadastro_empresa: 'Company successfully registered',
  sucesso_editar_empresa: 'Company edited successfully',
  sucesso_ativar_empresa: 'Company successfully activated!',
  sucesso_inativar_empresa: 'Company successfully deactivated!',
  ativar: 'Activate',
  inativar: 'Deactivate',
  deseja_ativar_empresa: 'Do you want to activate the company',
  deseja_inativar_empresa: 'Do you want to deactivate the company',
  buscar_cnpj: 'Search for companies by CNPJ',
  empresas_total_encontradas: 'Total of registered companies',
  empresa_incluir_nova: 'Include new company',
  imprimir: "Print",
  baixar: "Download",
  enviar_email_recuperacao_senha: "Send e-mail to register password",
  sucesso_envio_recuperacao_senha: "The password reset link was sent successfully!",
  sucesso_impressao: 'Printed successfully!',
  erro_impressao: 'Something unexpected happened during the printing process.',
  imprimindo: 'Printing...',

  merge_msg_1: "The existence of a registration with this document using the e-mail was identified: ",
  merge_msg_2: "Do you want to merge the records?",
  merge_msg_3: "If you confirm, the name and e-mail of this record will be added to the existing record!",

  remove_foto: "Photo successfully removed",
  visualizar_foto: "View photo",
  delete_photo: "Delete photo",
  ver_foto: "View photo",
  statusFacial: "Facial Status",
  ultimaAtualizacao: "Last Update",

  status: "Status",
  status_realizado: "Completed",
  sem_registros: "No records",
  sincronizacao: "Synchronization",
  label_confirmar_email: "Confirm your e-mail address to proceed",
  confirmar_email: "Confirm e-mail",
  email_diferente: "The e-mail address entered does not correspond to the one registered",
  categoria: "Category",

  portaria_importar_lista: 'Import people list',
  portaria_campos_obrigatorios: ' Required fields: Start, End.',
  portaria_motivo_obrigatorio: "Fill in reason for visit to proceed.",
  portaria_tipo_documento: "Document type",

  no_data: "No data",
  qrcode_complete_onboarding: "Scan this QR Code and complete your onboarding",
  qrcode_complete_onboarding_recepcao: "Use this QR Code to access Caldeira",
  qrcode_onboarding: "QR Code onboarding",
  loading: "Loading...",
  sucesso_cadastro_visita: "Registration completed successfully!",
  sucesso_cadastro_visita_msg: "An onboarding link has been sent to the visitor's email.",
  enviar_qrcode_visita_email: "Send visit QRCode by email",
};
